// extracted by mini-css-extract-plugin
export default {"text":"ReadMore_text__dtiCn","readMoreLink":"ReadMore_readMoreLink__uhc-U"};